"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _ChatSession;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classPrivateMethodInitSpec(obj, privateSet) { _checkPrivateRedeclaration(obj, privateSet); privateSet.add(obj); }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) { _classCheckPrivateStaticAccess(receiver, classConstructor); _classCheckPrivateStaticFieldDescriptor(descriptor, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classCheckPrivateStaticFieldDescriptor(descriptor, action) { if (descriptor === undefined) { throw new TypeError("attempted to " + action + " private static field before its declaration"); } }
function _classCheckPrivateStaticAccess(receiver, classConstructor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } }
function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }
function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }
function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }
function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }
function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }
angular.module("core").directive("ngUserInput", function () {
  return {
    restrict: "A",
    scope: {
      onEnterCallback: "=ngUserInput",
      inputIsEmpty: "=",
      busy: "="
    },
    template: "<textarea class=\"text\" cols=\"40\" rows=\"3\" placeholder=\"{{ busy ? 'Please wait...' : 'Type your message here and press enter to send' }}\" ng-model=\"userInput\" ng-change=\"checkInput(userInput)\"></textarea>",
    replace: true,
    link: function link(scope, element) {
      scope.userInput = "";
      scope.checkInput = function () {
        scope.inputIsEmpty = !scope.userInput || !scope.userInput.length;
      };

      // detect enter key press to submit
      $(element).keypress(function (e) {
        var code = e.keyCode ? e.keyCode : e.which;
        // check if key is enter
        if (code === 13 && !e.shiftKey) {
          e.preventDefault();
          if (!scope.userInput.length) {
            return false;
          }
          scope.$apply(function () {
            scope.onEnterCallback(scope.userInput);
            scope.userInput = "";
            scope.inputIsEmpty = true;
          });
          return false;
        }
      });
    }
  };
});

/**
 * ** A note about Bot Scripts **
 * Bot Scripts, simply referred to as 'script' are backend scripted routines
 * A script is a mode the bot goes into, that will then respond to input based on 
 * what is expected by the script. 
 * For example the meaning of 'yes' might be in response to a specific question in the script
 * Then there will be a follow-up response.
 * The backend decides when and whether we are in a 'script'. 
 * Menu items can have the property 'script', and this can trigger a script.
 * The scripts can be found in `deploy/application/library/bot/scripts`
 * The Bot frontend is passive to scripts but what is important is that if the API returns the property 'script'
 * then the frontend must relay this back to the API when the user responds, either in a comment or by clicking a menu button
 * If the menu button has its own script property this takes precedence. But if it is null then any script passed by the API
 * should be returned to the API.
 * This is critical to tell the backend that we are still in the script. 
 * Otherwise the response would be received out of context, and would likely result in a 'I do not understand this' response.
 */

angular.module("bot", ["core", "constants", "ngSanitize", "ngAnimate", "LocalStorageModule", "videos"]).config(function ($httpProvider, $logProvider, $qProvider) {
  "use strict";

  $httpProvider.defaults.headers.post["Content-Type"] = "application/json";
  $logProvider.debugEnabled(false);
  $qProvider.errorOnUnhandledRejections(false);
}).constant("CONFIGPATH", null).constant("BOT_EVENTS", {
  chatSessionReady: "chat_sess_r",
  chatSessionRefreshed: "chat_sess_u",
  doReset: "chat_sess_reset",
  menuStatusEvent: "e_menu_status",
  scrollToEnd: "e_scroll"
}).directive("ngBot", function ($interval, $location, $rootScope, $timeout, Bot, BOT_EVENTS, ChatSession, EVENTS, System) {
  return {
    restrict: "A",
    templateUrl: "/angularjs/partials/bot-panel.html",
    replace: true,
    scope: {
      viewMode: "@ngBot"
    },
    link: function link(scope) {
      var transcriptLength = null;
      var activateFromExternalEvent = null;
      var scrollTimer = null;
      var bubbleInitTimer = null;
      var isAlwaysAwakeMode = false;
      var showingTyping = false;

      // default view mode is the floating panel
      scope.floating = scope.viewMode === "floating";
      isAlwaysAwakeMode = scope.viewMode === "sidebar";
      scope.bot = Bot.getStatus();
      scope.session = ChatSession.session;
      scope.showTyping = ChatSession.showTyping;

      // check for showTyping and scroll to max
      // for some reason this won't work on a watcher, simply by binding scope.showTyping to ChatSession.showTyping
      $interval(function () {
        scope.showTyping = ChatSession.showTyping;
        if (showingTyping !== scope.showTyping) {
          showingTyping = scope.showTyping;
          if (showingTyping) {
            $timeout(function () {
              scope.scrollToMax();
            }, 10);
          } else {
            $timeout(function () {
              scope.scrollToMax();
            }, 400);
          }
        }
      }, 300);

      // this is to scroll past the end of the messages when the menu appears
      scope.$watch("session.menuOnlyMode", function (newMode) {
        if (!newMode) {
          $timeout(function () {
            scope.scrollToMax();
          }, 500);
        }
      });
      scope.$watch("session.isStalled", function (isStalled) {
        if (isStalled) {
          var onStalledSuggestion = ChatSession.onStalledSuggestion;
          scope.injectSuggestion(onStalledSuggestion.content, onStalledSuggestion.key);
        }
      });
      scope.suggestions = [];
      scope.botContext = scope.botContext || {};
      scope.inputIsEmpty = true; // see directive ng-user-input, actual value of userInput is private to that directive
      scope.disableMenu = false;
      scope.ready = false;

      // - - scope methods - - //

      scope.togglePanel = function (flag) {
        ChatSession.togglePanel(flag);
        $rootScope.$broadcast(EVENTS.botPanelState, {
          panelOpen: flag
        });
        scope.scrollToMax();
        scope.dismissBubble();
      };
      scope.dismissBubble = function () {
        ChatSession.dismissBubble();
        if (bubbleInitTimer) {
          $timeout.cancel(bubbleInitTimer);
        }
        if (scope.bubbleClasses) {
          scope.bubbleClasses = "show animated bounceOutDown";
          $timeout(function () {
            return scope.bubbleClasses = "";
          }, 3000);
        }
      };
      scope.initBubble = function () {
        if (bubbleInitTimer) {
          $timeout.cancel(bubbleInitTimer);
        }
        bubbleInitTimer = $timeout(function () {
          return scope.bubbleClasses = "show animated bounceInUp";
        }, 30000);
      };

      /**
       * 
       * @param {*} value 
       */
      scope.getInput = function (value) {
        scope.suggestions = [];
        scope.botContext.url = $location.absUrl();
        Bot.ask(value, scope.botContext);
      };

      /**
       * Injects question via button clicked in the Bot interface
       * @param {string} question 
       */
      scope.injectSuggestion = function (question, menuKey) {
        // we use menuKey BOT_MENU_KEY_CLOSE_TICKET on the frontend to identify and intercept this click and show a confirm prompt
        // note that we need to remove the key from the payload because the backend doesn't recognise it as a menu, and would return a null response
        // simplest way: reinject the same question without the menuKeu
        if (menuKey && menuKey === ChatSession.BOT_MENU_KEY_CLOSE_TICKET) {
          return System.confirm({
            title: "Close your support ticket?",
            message: "Are you sure? Your conversaion with the WRP Team will end and you will be passed back to the virtual assistant.",
            buttons: {
              okButton: "Close ticket",
              cancelButton: "Keep open"
            }
          }).then(function () {
            return scope.injectSuggestion(question, null);
          });
        }
        scope.botContext.url = $location.absUrl();
        Bot.ask(question, scope.botContext, menuKey || null);
        ChatSession.useSuggestion(question);
        scope.suggestions = [];
        //scope.refreshSuggestions();
      };

      /**
       * 
       * @param {*} question 
       * @param {*} menuKey 
       */
      scope.injectMenuQuestion = function (question, menuKey) {
        scope.disableMenu = true;
        $timeout(function () {
          scope.botContext.url = $location.absUrl();
          Bot.ask(question, scope.botContext, menuKey);
        }, 250);
        $timeout(function () {
          return ChatSession.clearMenuOnUse();
        }, 500);
      };

      /**
       * Injects question from outside the Bot app
       * Note that it can be triggered with no question
       * this has the effect of just opening the Bot panel
       */
      $rootScope.$on(EVENTS.askBotEvent, function (e, params) {
        if (scope.ready) {
          scope.togglePanel(true);
          if (params.question) {
            scope.suggestions = [];
            scope.botContext.url = $location.absUrl();
            // scope.togglePanel(true) opens the panel and if there is not already an active chat session
            // this triggers bot-factory to call /api/2/support/chat/start-session. as this is asynchronous
            // we need to wait till we have a conversation key before asking the question
            var cancelWatch = scope.$watch("session.conversation_key", function (newValue) {
              if (newValue) {
                ChatSession.clearMenu();
                Bot.ask(params.question, scope.botContext);
                cancelWatch();
              }
            });
          }
        }
      });
      scope.onBotMetaCallback = function (botMetadata) {
        return scope.botContext = botMetadata;
      };
      scope.refreshSuggestions = function () {
        return scope.suggestions = ChatSession.getSuggestions(scope.botContext);
      };
      scope.activateMapLinks = function () {
        // outside of Angular scope
        if (WRP && WRP.DeliveryMap) {
          WRP.DeliveryMap.initBot('.bot-lg-container');
        }
      };
      scope.scrollToMax = function (instantMode) {
        if (scrollTimer) {
          $timeout.cancel(scrollTimer);
        }
        scrollTimer = $timeout(function () {
          var scrollingElement = document.getElementById("contact-chat-panel");
          if (scrollingElement) {
            if (instantMode) {
              scrollingElement.scrollTop = scrollingElement.scrollHeight;
            } else {
              scrollingElement.scrollTo({
                top: scrollingElement.scrollHeight,
                behavior: 'smooth'
              });
            }
          }
          scope.activateMapLinks();
        }, 0);
      };
      scope.allReset = function () {
        ChatSession.reset();
        Bot.reset();
      };

      // - - end scope methods --  // 

      // allow for scroll to top button on long products listing pages
      scope.scrollButtonVisible = false;
      $rootScope.$on(EVENTS.scrollButtonEvent, function (e, params) {
        return scope.scrollButtonVisible = params.show;
      });
      $rootScope.$on(BOT_EVENTS.chatSessionRefreshed, function (e, params) {
        if (scope.session && scope.session.transcript && scope.session.transcript.length) {
          if (scope.session.transcript.length > transcriptLength) {
            transcriptLength = scope.session.transcript.length;
            scope.scrollToMax();
          }
          // special case after reset, needed becuase transcriptLength may not have changed but we need to scroll to max anyway
          // but we must not scroll to max EVERY time otherwise even when nothing has changed it scrolls to the bottom
          // which is frustrating for the user as they may have scrolled up to read a previous comment
          if (params && params.didReset) {
            scope.scrollToMax();
          }
          if (params && params.fromServer) {
            scope.refreshSuggestions();
          }
        }
      });
      $rootScope.$on(EVENTS.activateTicketEvent, function (e, params) {
        if (params.conversation_key) {
          activateFromExternalEvent = {
            conversation_key: params.conversation_key
          };
          if (scope.ready) {
            ChatSession.reset(params.conversation_key);
            Bot.reset();
            scope.scrollToMax();
            // @NOTE if the external event comes quickly enough then this won't happen
            // but otherwise prevent bubble when coming from an activate ticket link
            scope.dismissBubble();
          }
        }
      });

      // we are using ngExternalEventDispatcher so this is broadcast outside of angular to tell the DOM / jQuery app we are ready
      // because jquery loads first we need to delay this, otherwise the listener is not ready in source/js/products-page.js
      $timeout(function () {
        $rootScope.$broadcast(EVENTS.eventListen, {
          eventType: EVENTS.angularReady,
          outbound: true
        });
        $rootScope.$broadcast(EVENTS.eventListen, {
          eventType: EVENTS.botPanelState,
          outbound: true
        });
        // broadcast of ready event was moved to when BOT_EVENTS.chatSessionReady is triggered by the chat session
        // $rootScope.$broadcast(EVENTS.angularReady, { module: 'bot' });
        // set up listener for *inbound* material change event
        $rootScope.$broadcast(EVENTS.eventListen, {
          eventType: EVENTS.materialChangeEvent,
          outbound: false,
          restrictModule: 'bot'
        });
      }, 600);

      // don't show prompt bubble to staff
      $rootScope.$on(BOT_EVENTS.chatSessionReady, function () {
        scope.ready = true;
        $timeout(function () {
          $rootScope.$broadcast(EVENTS.angularReady, {
            module: 'bot'
          });
        }, 100);
        scope.scrollToMax();
        if (scope.session && scope.session.userStatus && scope.session.userStatus.user_is_staff) {
          scope.dismissBubble();
        }
        scope.refreshSuggestions();
      });
      $rootScope.$on(EVENTS.materialChangeEvent, function (e, params) {
        scope.botContext.material_id = params.materialId;
        scope.botContext.material_name = params.materialName;
      });

      /**
       * APP STARTS HERE
       */
      System.init().then(function () {
        Bot.init(isAlwaysAwakeMode); // sets up listeners
        ChatSession.init(); // starts a new session (or retrieves / restores one)
        // scope.ready = true; // NOTE this is set true on BOT_EVENTS.chatSessionReady
        // on init scroll instantly
        scope.scrollToMax(true);
        if (activateFromExternalEvent) {
          ChatSession.reset(activateFromExternalEvent.conversation_key);
          Bot.reset();
          scope.scrollToMax();
        } else {
          if (!isAlwaysAwakeMode) {
            if (!scope.session.bubbleDismissed) {
              scope.initBubble();
            }
          }
        }
        $rootScope.$on(BOT_EVENTS.doReset, function () {
          return $timeout(function () {
            return scope.allReset();
          }, 2000);
        });
        $rootScope.$on(BOT_EVENTS.menuStatusEvent, function (e, params) {
          return scope.disableMenu = !params.enabled;
        });
        $rootScope.$on(BOT_EVENTS.scrollToEnd, function (e, params) {
          return $timeout(function () {
            return scope.scrollToMax();
          }, 500);
        });
      }, function (reason) {
        return System.alert({
          title: "An error occurred",
          message: "An error occurred: " + reason
        });
      });
    }
  };
});
angular.module("bot").factory("Bot", function ($interval, $log, $q, $rootScope, $timeout, API, BOT_EVENTS, ChatSession, EVENTS) {
  var SERVER_REFRESH_INTERVAL = 7000;
  var HUMANISE_DELAY = 4000;
  var HUMANISE_DELAY_MENU = 1000;
  var COMMENT_TYPE_NULL = "ctype_null";
  var status = {
    busy: true,
    awake: false,
    waitingForInput: false
  };
  var startSessionCalled = false;
  var session;
  var sessionCache = "";
  var serverRefreshIntervalPromise = null;
  var isAlwaysAwakeMode = false;
  var init = function init(alwaysAwakeMode) {
    isAlwaysAwakeMode = !!alwaysAwakeMode;
    if (isAlwaysAwakeMode) {
      status.awake = true;
    }
    $rootScope.$on(EVENTS.botPanelState, function (e, params) {
      status.awake = isAlwaysAwakeMode || session.panelOpen;
      _updateStatus();
    });
    $rootScope.$on(BOT_EVENTS.chatSessionReady, function () {
      if (_checkForSessionChanges()) {
        _updateStatus();
      }
    });
    $rootScope.$on(BOT_EVENTS.chatSessionRefreshed, function () {
      if (_checkForSessionChanges()) {
        _updateStatus();
      }
    });
  };
  var reset = function reset() {
    status.busy = true;
    status.awake = false;
    status.waitingForInput = false;
    startSessionCalled = false;
  };
  var _checkForSessionChanges = function _checkForSessionChanges() {
    session = ChatSession.session;
    if (JSON.stringify(session) === sessionCache) {
      return false;
    }
    sessionCache = JSON.stringify(session);
    status.awake = isAlwaysAwakeMode || session && session.panelOpen;
    return true;
  };
  var _updateStatus = function _updateStatus() {
    // check for error state
    if (!session.conversation_key && session.transcript.length) {
      ChatSession.setErrorMessage("Existing chat session is missing a conversation_key. Click 'Reset chat session' to start a new session.");
      status.busy = true;
      return $log.warn("Bot error: found chat transcript without conversation_key. Stopping");
    }
    if (status.awake) {
      if (!session.conversation_key && !startSessionCalled) {
        startSessionCalled = true;
        _startNewSession();
      }
      if (!serverRefreshIntervalPromise) {
        serverRefreshIntervalPromise = $interval(function () {
          ChatSession.refreshFromServer();
        }, SERVER_REFRESH_INTERVAL); // server refresh checks for messages pushed from the server that won't be in the session
      }
      status.busy = false;
    } else {
      if (serverRefreshIntervalPromise) {
        $interval.cancel(serverRefreshIntervalPromise);
        serverRefreshIntervalPromise = null;
      }
    }
  };

  // should only run once per chat session
  var _startNewSession = function _startNewSession() {
    var unknownErrorMessage = "An unknown error occurred trying to start chat session";
    API.get("/2/bot/chat/start-session").then(function (response) {
      if (!response.success || !response.transcript || !response.transcript.length) {
        session.errorMessage = unknownErrorMessage;
        return;
      }
      ChatSession.setKey(response.conversation_key);

      // a new session always contains a transcript of length 1 unless restoring an existing session from login when can contain more
      response.transcript.forEach(function (comment) {
        ChatSession.addComment(comment);
      });
      ChatSession.setMenu(response.menu, response.menuOnlyMode);
      status.waitingForInput = true;
    }, function (response) {
      session.errorMessage = response || unknownErrorMessage;
    }).finally(function () {
      status.busy = false;
    });
  };

  /**
   * 
   * @param {string} input 
   * @param {object} botContext 
   * @param {string | null} menuKey 
   * @returns {promise}
   */
  var ask = function ask(input, botContext) {
    var menuKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var deferred = $q.defer();
    var unknownErrorMessage = "An unknown error occurred trying to store your message";
    if (!session.conversation_key) {
      session.errorMessage = "No conversation key, cannot continue";
      return $q.reject();
    }
    var metadata = {
      context: botContext
    };
    if (menuKey) {
      metadata.menuKey = menuKey;
    }
    // add any session script to the response. this is essential to pass the response back to the script on the server
    // NOTE when we accept external button clicks that inject bot questions
    // these will need to clear the script as they change to a fresh context
    if (session.script) {
      metadata.script = session.script;
    }
    API.post("/2/bot/chat/" + session.conversation_key + "/user-comments", {
      content: input.trim(),
      metadata: metadata
    }).then(function (response) {
      if (!response.success) {
        session.errorMessage = unknownErrorMessage;
        return $q.reject();
      }
      if (!response.comment.id) {
        $log.error("Comment has no ID, cannot continue");
        return $q.reject("Comment has no ID, cannot continue");
      }

      // add users's response to the session and process
      ChatSession.addComment(response.comment);
      ChatSession.setAnalyse(true);
      _respondToUserInput(response.comment, menuKey);
      deferred.resolve();
    }, function (response) {
      session.errorMessage = response && response.message ? response.message : unknownErrorMessage;
      deferred.reject();
    });
    return deferred.promise;
  };
  var _respondToUserInput = function _respondToUserInput(userComment, menuKey) {
    var deferred = $q.defer();
    var workingTimeout = menuKey ? HUMANISE_DELAY_MENU : HUMANISE_DELAY;
    var unknownErrorMessage = "An unknown error occurred trying to process your message";
    status.waitingForInput = false;

    // @NOTE we should arguably do this as part of when the user posts the question, then fake a delay before posting the bot's response
    // however separating them is simpler for initial development
    $timeout(function () {
      API.post("/2/bot/chat/" + session.conversation_key + "/analyse", {
        comment: userComment
      }).then(function (response) {
        if (!response.success) {
          session.errorMessage = unknownErrorMessage;
          return $q.reject();
        }

        // add bot's response to the session
        if (response.comment) {
          if (response.comment.type !== COMMENT_TYPE_NULL) {
            if (!response.comment.id) {
              $log.error("Comment has no ID, cannot continue");
              return $q.reject("Comment has no ID, cannot continue");
            }
            ChatSession.addComment(response.comment);
          }
        }
        if (response.menu) {
          ChatSession.setMenu(response.menu, response.menuOnlyMode || false, true);
        } else {
          ChatSession.clearMenu();
        }
        if (response.script) {
          ChatSession.setScript(response.script);
        } else {
          ChatSession.clearScript();
        }
        deferred.resolve();
      }, function (response) {
        session.errorMessage = response && response.message ? response.message : unknownErrorMessage;
        deferred.reject();
      }).finally(function () {
        ChatSession.setAnalyse(false);
      });
    }, workingTimeout);
  };
  return {
    ask: ask,
    getStatus: function getStatus() {
      return status;
    },
    init: init,
    reset: reset
  };
});
var _SESSION_MAX_AGE = /*#__PURE__*/new WeakMap();
var _SESSION_REFRESH_INTERVAL = /*#__PURE__*/new WeakMap();
var _CHECK_OFFICE_OPEN_INTERVAL = /*#__PURE__*/new WeakMap();
var _KEY_USER_DIRECT_ACCESS = /*#__PURE__*/new WeakMap();
var _BOT_MENU_KEY_BACK_TO_START = /*#__PURE__*/new WeakMap();
var _PATTERN_PROD_CODE = /*#__PURE__*/new WeakMap();
var _REGEX_PROD_CODE = /*#__PURE__*/new WeakMap();
var _session2 = /*#__PURE__*/new WeakMap();
var _analyseActive = /*#__PURE__*/new WeakMap();
var _suggestedQuestionPool = /*#__PURE__*/new WeakMap();
var _sessionRefreshIntervalPromise = /*#__PURE__*/new WeakMap();
var _officeOpenRefreshIntervalPromise = /*#__PURE__*/new WeakMap();
var _reloadsWithoutBotResponse = /*#__PURE__*/new WeakMap();
var _transcriptContainsComment = /*#__PURE__*/new WeakSet();
var _writeSession = /*#__PURE__*/new WeakSet();
var _readSession = /*#__PURE__*/new WeakSet();
var _processTranscript = /*#__PURE__*/new WeakSet();
var _getUserIsWaiting = /*#__PURE__*/new WeakSet();
var ChatSession = /*#__PURE__*/function () {
  function ChatSession($interval, $rootScope, API, BOT_EVENTS, LocalStorage, USER_TYPES, Utils) {
    _classCallCheck(this, ChatSession);
    _classPrivateMethodInitSpec(this, _getUserIsWaiting);
    _classPrivateMethodInitSpec(this, _processTranscript);
    _classPrivateMethodInitSpec(this, _readSession);
    _classPrivateMethodInitSpec(this, _writeSession);
    _classPrivateMethodInitSpec(this, _transcriptContainsComment);
    _defineProperty(this, "$interval", void 0);
    _defineProperty(this, "$rootScope", void 0);
    _defineProperty(this, "API", void 0);
    _defineProperty(this, "BOT_EVENTS", void 0);
    _defineProperty(this, "LocalStorage", void 0);
    _defineProperty(this, "USER_TYPES", void 0);
    _defineProperty(this, "Utils", void 0);
    _classPrivateFieldInitSpec(this, _SESSION_MAX_AGE, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _SESSION_REFRESH_INTERVAL, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _CHECK_OFFICE_OPEN_INTERVAL, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _KEY_USER_DIRECT_ACCESS, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _BOT_MENU_KEY_BACK_TO_START, {
      writable: true,
      value: void 0
    });
    _defineProperty(this, "BOT_MENU_KEY_CLOSE_TICKET", void 0);
    _classPrivateFieldInitSpec(this, _PATTERN_PROD_CODE, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _REGEX_PROD_CODE, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _session2, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _analyseActive, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _suggestedQuestionPool, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _sessionRefreshIntervalPromise, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _officeOpenRefreshIntervalPromise, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _reloadsWithoutBotResponse, {
      writable: true,
      value: void 0
    });
    this.$interval = $interval;
    this.$rootScope = $rootScope;
    this.API = API;
    this.BOT_EVENTS = BOT_EVENTS;
    this.LocalStorage = LocalStorage;
    this.USER_TYPES = USER_TYPES;
    this.Utils = Utils;
    _classPrivateFieldSet(this, _SESSION_MAX_AGE, 1000 * 60); // 1 minute
    _classPrivateFieldSet(this, _SESSION_REFRESH_INTERVAL, 3500); // @NOTE this is checks the this.#session. The *server* refresh interval is triggered here from the bot, every 10 seconds
    _classPrivateFieldSet(this, _CHECK_OFFICE_OPEN_INTERVAL, 1000 * 60);
    _classPrivateFieldSet(this, _KEY_USER_DIRECT_ACCESS, 'user_sda');
    _classPrivateFieldSet(this, _BOT_MENU_KEY_BACK_TO_START, 'key_back_to_start');
    this.BOT_MENU_KEY_CLOSE_TICKET = 'key_close_ticket';
    _classPrivateFieldSet(this, _PATTERN_PROD_CODE, '{{ product_code }}');
    _classPrivateFieldSet(this, _REGEX_PROD_CODE, new RegExp(_classPrivateFieldGet(this, _PATTERN_PROD_CODE), 'g'));
    _classPrivateFieldSet(this, _session2, {
      conversation_key: null,
      panelOpen: false,
      bubbleDismissed: false,
      activeTicket: false,
      transcript: [],
      menu: null,
      menuOnlyMode: false,
      userStatus: {},
      teamStatus: {},
      errorMessage: null,
      suggestedQuestionsAsked: [],
      isStalled: false
    });
    _classPrivateFieldSet(this, _analyseActive, false);
    _classPrivateFieldSet(this, _suggestedQuestionPool, {
      backToOptions: {
        singleUse: false,
        button: "Start again",
        content: "Start again",
        isStartAgain: true,
        key: _classPrivateFieldGet(this, _BOT_MENU_KEY_BACK_TO_START)
      },
      onStalled: {
        singleUse: false,
        button: "Show menu",
        content: "[Show menu]",
        key: _classPrivateFieldGet(this, _BOT_MENU_KEY_BACK_TO_START)
      },
      requestSupportLive: {
        singleUse: false,
        button: "Talk to the team",
        content: "Talk to the team"
      },
      requestSupportOffline: {
        singleUse: false,
        button: "Open support ticket",
        content: "Open support ticket"
      },
      closeSupportTicket: {
        singleUse: false,
        button: "Close support ticket",
        content: "Close support ticket",
        key: this.BOT_MENU_KEY_CLOSE_TICKET
      },
      askAboutProduct: {
        singleUse: true,
        button: "Ask about " + _classPrivateFieldGet(this, _PATTERN_PROD_CODE),
        content: "Tell me more about " + _classPrivateFieldGet(this, _PATTERN_PROD_CODE)
      }
    });
    _classPrivateFieldSet(this, _sessionRefreshIntervalPromise, null);
    _classPrivateFieldSet(this, _officeOpenRefreshIntervalPromise, null);
    _classPrivateFieldSet(this, _reloadsWithoutBotResponse, 0);
  }
  return _createClass(ChatSession, [{
    key: "init",
    value: function init(didReset) {
      var _this = this;
      didReset = didReset || false;
      _classPrivateFieldSet(this, _session2, _classPrivateMethodGet(this, _readSession, _readSession2).call(this, _classPrivateFieldGet(this, _session2)));
      _classPrivateFieldSet(this, _reloadsWithoutBotResponse, 0);
      this.API.get("/2/users/self/status").then(function (response) {
        if (!response.success) {
          _classPrivateFieldGet(_this, _session2).errorMessage = "An unknown error occurred at get user status";
          return;
        }
        _classPrivateFieldGet(_this, _session2).userStatus = response.status;
        _classPrivateFieldGet(_this, _session2).teamStatus = response.team_status;
        _classPrivateMethodGet(_this, _writeSession, _writeSession2).call(_this, _classPrivateFieldGet(_this, _session2));
        _this.$rootScope.$broadcast(_this.BOT_EVENTS.chatSessionReady, null);
        if (_classPrivateFieldGet(_this, _session2).conversation_key) {
          refreshFromServer(didReset);
        }
        if (!_classPrivateFieldGet(_this, _sessionRefreshIntervalPromise)) {
          _classPrivateFieldSet(_this, _sessionRefreshIntervalPromise, _this.$interval(function () {
            _classPrivateFieldSet(_this, _session2, _classPrivateMethodGet(_this, _readSession, _readSession2).call(_this, _classPrivateFieldGet(_this, _session2)));
          }, _classPrivateFieldGet(_this, _SESSION_REFRESH_INTERVAL)));
        }
        if (!_classPrivateFieldGet(_this, _officeOpenRefreshIntervalPromise)) {
          _classPrivateFieldSet(_this, _officeOpenRefreshIntervalPromise, _this.$interval(function () {
            // do nothing if the panel is open
            // we only need to separately check if support is live when the panel is closed
            // this is because when the panel is open the this.#session refreshes regularly, and the sesssion payload contains the live support status
            if (_classPrivateFieldGet(_this, _session2) && _classPrivateFieldGet(_this, _session2).panelOpen) {
              return;
            }
            _this.refreshOfficeOpenStatusFromServer();
          }, _classPrivateFieldGet(_this, _CHECK_OFFICE_OPEN_INTERVAL)));
        }
      }, function (response) {
        _classPrivateFieldGet(_this, _session2).errorMessage = response;
      });
    } // end init
  }, {
    key: "onStalledSuggestion",
    get: function get() {
      return _classPrivateFieldGet(this, _suggestedQuestionPool).onStalled;
    }
  }, {
    key: "dismissBubble",
    value: function dismissBubble() {
      _classPrivateFieldGet(this, _session2).bubbleDismissed = true;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }

    /**
     * 
     * @param {?string} conversationKeyOrNull - if passing a key we activate an existing chat (realistically this will be a support ticket), otherwise we reset to a new blank chat
     */
  }, {
    key: "reset",
    value: function reset(conversationKeyOrNull) {
      var resetWithKey = conversationKeyOrNull ? true : false;
      var session = _classPrivateFieldGet(this, _session2);
      session.conversation_key = conversationKeyOrNull || null;
      session.panelOpen = resetWithKey;
      session.activeTicket = resetWithKey;
      session.transcript = [];
      session.menu = null;
      session.menuOnlyMode = false;
      session.userStatus = {};
      session.teamStatus = {};
      session.errorMessage = null;
      session.suggestedQuestionsAsked = [];
      session.isStalled = false;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, session);
      this.init(resetWithKey);
    }
  }, {
    key: "setErrorMessage",
    value: function setErrorMessage(message) {
      _classPrivateFieldGet(this, _session2).errorMessage = message || null;
    }
  }, {
    key: "setKey",
    value: function setKey(conversation_key) {
      _classPrivateFieldGet(this, _session2).conversation_key = conversation_key;
    }
  }, {
    key: "togglePanel",
    value: function togglePanel(flag) {
      _classPrivateFieldGet(this, _session2).panelOpen = flag;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }
  }, {
    key: "getSuggestions",
    value: function getSuggestions(botContext) {
      var suggestions = [];
      var addSuggestionToList = function addSuggestionToList(suggestion, suggestions, suggestedQuestionsAsked) {
        if (!suggestion.singleUse || suggestedQuestionsAsked.indexOf(suggestion.content) === -1) {
          suggestions.push(suggestion);
        }
      };

      // other than the above case, only show suggestions when the last comment was from the BOT
      // this prevents the suggestions from reappearing as soon as the user has typed someting and before the bot has responded
      var lastComment = _classPrivateFieldGet(this, _session2).transcript[_classPrivateFieldGet(this, _session2).transcript.length - 1];
      var questionsAsked = _classPrivateFieldGet(this, _session2).suggestedQuestionsAsked;
      if (!lastComment) {
        return [];
      }
      if (_classPrivateFieldGet(this, _session2).activeTicket) {
        addSuggestionToList(_classPrivateFieldGet(this, _suggestedQuestionPool).closeSupportTicket, suggestions, questionsAsked);
        return suggestions;
      }
      if (lastComment.userType === "customer") {
        return [];
      }

      // it user has support direct access
      if (_classPrivateFieldGet(this, _session2).userStatus && _classPrivateFieldGet(this, _session2).userStatus[_classPrivateFieldGet(this, _KEY_USER_DIRECT_ACCESS)]) {
        var questionToUse = _classPrivateFieldGet(this, _session2).teamStatus && _classPrivateFieldGet(this, _session2).teamStatus.support_team_online ? _classPrivateFieldGet(this, _suggestedQuestionPool).requestSupportLive : _classPrivateFieldGet(this, _suggestedQuestionPool).requestSupportOffline;
        addSuggestionToList(questionToUse, suggestions, questionsAsked);
      }

      // @TODO add more suggestions here (e.g. based on user status OR what page they are on)
      if (botContext.page_type === "product" && botContext.product_id && botContext.product_code) {
        var suggestion = angular.copy(_classPrivateFieldGet(this, _suggestedQuestionPool).askAboutProduct);
        suggestion.button = suggestion.button.replace(_classPrivateFieldGet(this, _REGEX_PROD_CODE), botContext.product_code);
        suggestion.content = suggestion.content.replace(_classPrivateFieldGet(this, _REGEX_PROD_CODE), botContext.product_code);
        if (!_classPrivateMethodGet(this, _transcriptContainsComment, _transcriptContainsComment2).call(this, suggestion.content)) {
          addSuggestionToList(suggestion, suggestions, questionsAsked);
        }
      }
      if (!_classPrivateFieldGet(this, _session2).menu) {
        suggestions.push(_classPrivateFieldGet(this, _suggestedQuestionPool).backToOptions);
      }
      return suggestions;
    }
  }, {
    key: "useSuggestion",
    value: function useSuggestion(sugestionContent) {
      _classPrivateFieldGet(this, _session2).suggestedQuestionsAsked.push(sugestionContent);
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }
  }, {
    key: "refreshFromServer",
    value: function refreshFromServer(didReset) {
      var _this2 = this;
      if (!_classPrivateFieldGet(this, _session2) || !_classPrivateFieldGet(this, _session2).conversation_key) {
        return;
      }
      didReset = didReset || false;
      this.API.get("/2/bot/chat/session/" + _classPrivateFieldGet(this, _session2).conversation_key).then(function (response) {
        var _classPrivateFieldGet2;
        if (!response.success) {
          _classPrivateFieldGet(_this2, _session2).errorMessage = "An unknown error occurred at get this.#session";
          return;
        }

        // in the case that the user had an active support this.#session (with WRP staff)
        // then they logged out, the this.#session will return a special state to tell the app to reset the this.#session (get a new key)
        if (response.doInvalidate) {
          _this2.$rootScope.$broadcast(_this2.BOT_EVENTS.doReset, null);
        } else {
          // unlikely because we don't delete them but still needs to be handled
          if (!response.transcript || !response.transcript.length) {
            console.warn("Chat transcript is empty, resetting");
            _this2.$rootScope.$broadcast(_this2.BOT_EVENTS.doReset, null);
            return;
          }
        }
        var existingTranscriptLength = (_classPrivateFieldGet2 = _classPrivateFieldGet(_this2, _session2).transcript.length) !== null && _classPrivateFieldGet2 !== void 0 ? _classPrivateFieldGet2 : 0;
        _classPrivateFieldGet(_this2, _session2).activeTicket = response.active_ticket;
        _classPrivateFieldGet(_this2, _session2).supportTicketId = response.support_ticket_id;
        _classPrivateFieldGet(_this2, _session2).transcript = _classPrivateMethodGet(_this2, _processTranscript, _processTranscript2).call(_this2, response.transcript) || [];
        _classPrivateMethodGet(_this2, _writeSession, _writeSession2).call(_this2, _classPrivateFieldGet(_this2, _session2));
        if (response.menu) {
          _this2.setMenu(response.menu, response.menuOnlyMode || false, false);
          _classPrivateFieldGet(_this2, _session2).isStalled = false; // never stalled when the user has a menu to click
          _classPrivateFieldSet(_this2, _reloadsWithoutBotResponse, 0);
        } else {
          _this2.clearMenu();
          if (!_classPrivateFieldGet(_this2, _session2).activeTicket) {
            _classPrivateFieldGet(_this2, _session2).isStalled = _classPrivateMethodGet(_this2, _getUserIsWaiting, _getUserIsWaiting2).call(_this2, response.lastCommentUser);
          } else {
            _classPrivateFieldGet(_this2, _session2).isStalled = false;
          }
        }
        if (response.script) {
          _this2.setScript(response.script);
        } else {
          _this2.clearScript();
        }
        _this2.$rootScope.$broadcast(_this2.BOT_EVENTS.chatSessionRefreshed, {
          fromServer: true,
          didReset: didReset
        });
        _this2.$rootScope.$broadcast(_this2.BOT_EVENTS.menuStatusEvent, {
          enabled: true
        });

        // if the transcript got longer then scroll to the bottom so they can see the new reply in view
        if (_classPrivateFieldGet(_this2, _session2).transcript.length > existingTranscriptLength) {
          _this2.$rootScope.$broadcast(_this2.BOT_EVENTS.scrollToEnd);
        }
        _classPrivateFieldGet(_this2, _session2).teamStatus = response.team_status;
      }, function (response) {
        _classPrivateFieldGet(_this2, _session2).errorMessage = response;
      });
    }
  }, {
    key: "refreshOfficeOpenStatusFromServer",
    value: function refreshOfficeOpenStatusFromServer() {
      var _this3 = this;
      this.API.get("/2/support/status").then(function (response) {
        if (!response.success) {
          return console.warn("Could not get support status");
        }
        if (!_classPrivateFieldGet(_this3, _session2)) {
          return console.warn("Session not yet loaded at getLiveSupportStatusFromServer");
        }
        _classPrivateFieldGet(_this3, _session2).teamStatus = response.team_status;
        _classPrivateMethodGet(_this3, _writeSession, _writeSession2).call(_this3, _classPrivateFieldGet(_this3, _session2));
      }, function (response) {
        console.warn("Get live status failed with response: ", response);
      });
    }

    /**
    * 
    * @param {object} commentObject 
    */
  }, {
    key: "addComment",
    value: function addComment(commentObject) {
      if (commentObject && commentObject.content) {
        commentObject.content = this.Utils.replaceUrls(commentObject.content);
      }
      _classPrivateFieldGet(this, _session2).transcript.push(commentObject);
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
      this.$rootScope.$broadcast(this.BOT_EVENTS.chatSessionRefreshed, null);
    }

    /**
     * 
     * @param {array} menu 
     * @param {bool} menuOnlyMode 
     */
  }, {
    key: "setMenu",
    value: function setMenu(menu, menuOnlyMode, broadcastEvents) {
      _classPrivateFieldGet(this, _session2).menu = angular.copy(menu);
      _classPrivateFieldGet(this, _session2).menuOnlyMode = menuOnlyMode || false;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
      if (broadcastEvents) {
        this.$rootScope.$broadcast(this.BOT_EVENTS.menuStatusEvent, {
          enabled: true
        });
        this.$rootScope.$broadcast(this.BOT_EVENTS.scrollToEnd);
      }
    }
  }, {
    key: "clearMenuOnUse",
    value: function clearMenuOnUse() {
      _classPrivateFieldGet(this, _session2).menu = null;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }
  }, {
    key: "clearMenu",
    value: function clearMenu() {
      _classPrivateFieldGet(this, _session2).menu = null;
      _classPrivateFieldGet(this, _session2).menuOnlyMode = false;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
      // $rootScope.$broadcast(this.BOT_EVENTS.chatSessionRefreshed, null); // not needed here?
    }
  }, {
    key: "setScript",
    value: function setScript(script) {
      _classPrivateFieldGet(this, _session2).script = script;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }
  }, {
    key: "clearScript",
    value: function clearScript() {
      delete _classPrivateFieldGet(this, _session2).script;
      _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, _classPrivateFieldGet(this, _session2));
    }
  }, {
    key: "session",
    get: function get() {
      return _classPrivateFieldGet(this, _session2);
    }
  }, {
    key: "showTyping",
    get: function get() {
      return _classPrivateFieldGet(this, _analyseActive) && !_classPrivateFieldGet(this, _session2).activeTicket;
    }

    /**
     * @param {boolean} flag
     */
  }, {
    key: "setAnalyse",
    value: function setAnalyse(flag) {
      _classPrivateFieldSet(this, _analyseActive, flag);
    }
  }]);
}();
_ChatSession = ChatSession;
function _transcriptContainsComment2(content) {
  return _classPrivateFieldGet(this, _session2).transcript.filter(function (comment) {
    return comment.content === content;
  }).length;
}
function _writeSession2(_session) {
  var sessionToWrite = angular.copy(_session);
  if (sessionToWrite.hasOwnProperty("errorMessage")) {
    delete sessionToWrite.errorMessage;
  }
  this.LocalStorage.write("supportSession", sessionToWrite);
}
function _readSession2(existingSession) {
  // @NOTE only properties of the existing this.#session will be updated from the browser session storage
  var sessionFromStorage = this.LocalStorage.read("supportSession", _classPrivateFieldGet(this, _SESSION_MAX_AGE));
  if (!sessionFromStorage) {
    _classPrivateMethodGet(this, _writeSession, _writeSession2).call(this, existingSession);
  } else {
    for (var property in existingSession) {
      if (sessionFromStorage.hasOwnProperty(property)) {
        existingSession[property] = sessionFromStorage[property];
      }
    }
  }
  this.$rootScope.$broadcast(this.BOT_EVENTS.chatSessionRefreshed, null);
  return existingSession;
}
function _processTranscript2(transcript) {
  var _this4 = this;
  if (!transcript || !transcript.length) {
    return [];
  }
  transcript.forEach(function (comment) {
    if (comment.metadata && comment.metadata.includes("youtube_key")) {
      var metadata = null;
      try {
        metadata = JSON.parse(comment.metadata);
        comment.youtube_key = metadata.youtube_key || null;
      } catch (error) {
        console.warn("Unable to read comment metadata: ", error);
      }
    }
    comment.content = _this4.Utils.replaceUrls(comment.content);
  });
  return transcript;
}
function _getUserIsWaiting2(lastCommentUser) {
  var _this$reloadsWithoutB, _this$reloadsWithoutB2;
  _classPrivateFieldSet(this, _reloadsWithoutBotResponse, (_this$reloadsWithoutB = _classPrivateFieldGet(this, _reloadsWithoutBotResponse), _this$reloadsWithoutB2 = _this$reloadsWithoutB++, _this$reloadsWithoutB)), _this$reloadsWithoutB2;
  if (lastCommentUser === this.USER_TYPES.USER_TYPE_CUSTOMER) {
    if (_classPrivateFieldGet(this, _reloadsWithoutBotResponse) >= _classStaticPrivateFieldSpecGet(_ChatSession, _ChatSession, _MAX_RELOADS_WITHOUT_BOT_RESPONSE)) {
      return true;
    }
    return false;
  } else {
    _classPrivateFieldSet(this, _reloadsWithoutBotResponse, 0);
    return false;
  }
}
var _MAX_RELOADS_WITHOUT_BOT_RESPONSE = {
  writable: true,
  value: 2
};
_defineProperty(ChatSession, "$inject", ['$interval', '$rootScope', 'API', 'BOT_EVENTS', 'LocalStorage', 'USER_TYPES', 'Utils']);
angular.module('bot').service('ChatSession', ChatSession);
angular.module("bot").directive("ngGetBotMeta", function ($log, $interval) {
  return {
    restrict: "A",
    link: function link(scope) {
      scope.onGotCallbackFunction = function () {
        if (!WRP || !WRP.BotMetadata) {
          console.warn("[ngGetBotMeta] global module WRP is not defined or missing WRP.BotMetadata");
        }
        WRP.BotMetadata.get().then(function (response) {
          scope.onBotMetaCallback(response);
          // because promise is resolved outside of angularjs, apply changes to the scope
          if (!scope.$$phase) {
            scope.$apply();
          }
        }, function (rejectResponse) {
          console.warn("[ngGetBotMeta] WRP.BotMetadata.get() failed with:", rejectResponse);
        });
      };

      // @NOTE shares scope with the parent, in which method onBotMetaCallback must exist for this to continue
      // in practice scope.onBotMetaCallback is already present and so this works first time
      var attempts = 5;
      var intervalPromise = $interval(function () {
        if (scope.onBotMetaCallback) {
          $interval.cancel(intervalPromise);
          scope.onGotCallbackFunction();
          return;
        } else {
          console.error("scope.onBotMetaCallback method is missing");
        }
        attempts--;
        if (attempts < 1) {
          $interval.cancel(intervalPromise);
          $log.warn("[ng-get-bot-meta] Could not find callback function");
        }
      }, 50);
    }
  };
});
angular.module("bot").directive("botMenuButton", function ($window) {
  return {
    restrict: "E",
    template: "<button type=\"button\" class=\"bot-menu-button\" ng-class=\"{'start-again': isStartAgain }\" ng-show=\"menuItem\" ng-click=\"click()\" ng-disabled=\"disable\">{{ label }}</button>",
    replace: true,
    scope: {
      menuItem: "=",
      handler: "=",
      disable: "="
    },
    link: function link(scope) {
      var menuItem = scope.menuItem;
      scope.isStartAgain = menuItem.label === 'Start again';
      scope.label = menuItem.label;
      scope.click = function () {
        if (menuItem.href) {
          return $window.location.href = menuItem.href;
        }
        scope.handler(menuItem.content, menuItem.key);
      };
    }
  };
});
angular.module("bot").directive("botTyping", function () {
  return {
    restrict: "E",
    template: "<div ng-show=\"show\" class=\"typing-indicator\" ng-class=\"{'ticket-mode': ticketMode, show: show, 'with-menu': withMenu}\"><span></span><span></span><span></span></div>",
    replace: true,
    scope: {
      ticketMode: "=",
      show: "=",
      withMenu: "="
    }
  };
});
angular.module("videos", []).directive("youtubeThumbnail", function ($sce) {
  return {
    restrict: "E",
    replace: true,
    template: '<div class="video-thumbnail" ng-bind-html="videoHtml"></div>',
    scope: {
      key: "@key"
    },
    link: function link(scope) {
      scope.videoHtml = $sce.trustAsHtml('<iframe src="https://www.youtube-nocookie.com/embed/' + scope.key + '?si=-1hKwy-tYYsRRBGi&amp;controls=0&amp;rel=0" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>');
    }
  };
});
angular.module("bot").run(["$templateCache", function ($templateCache) {
  $templateCache.put("/angularjs/partials/bot-panel.html", "<div class=\"contact-system {{::floating ? \'bot-floating\' : \'bot-sidebar\'}}\" ng-external-event-listener ng-get-bot-meta parent-module=\"bot\" ng-class=\"{\'shift-up\': scrollButtonVisible, loading: !ready}\"><button type=\"button\" ng-click=\"togglePanel(true)\" class=\"contact-show-button\" ng-class=\"{\'support-team-online\': session.userStatus.user_sda && session.teamStatus.support_team_online}\" ng-hide=\"session.panelOpen\">Show</button><div class=\"speech-bubble\" ng-class=\"bubbleClasses\" ng-click=\"togglePanel(true); dismissBubble();\"><p>I’m your <strong>Virtual Assistant</strong>. I can answer the vast majority of questions. Click to chat with me!</p><button class=\"close-button\" ng-click=\"dismissBubble(); $event.stopPropagation();\">Close</button></div><div class=\"contact-panel\" ng-class=\"{\'priority-customer\': session.userStatus.user_sda, \'support-team-online\': session.userStatus.user_sda && session.teamStatus.support_team_online}\" ng-show=\"session.panelOpen || !floating\"><div class=\"contact-panel-header\"><h1 ng-show=\"!session.activeTicket && !session.userStatus.user_sda\">WRP Assistant</h1><h1 ng-show=\"!session.activeTicket && session.userStatus.user_sda\">Priority Customer Support</h1><h1 ng-show=\"session.activeTicket\">Support ticket {{ session.supportTicketId }}</h1><button type=\"button\" class=\"contact-panel-close-button\" ng-click=\"togglePanel(false)\">Close</button></div><div class=\"live-header\" ng-show=\"session.userStatus.user_sda && session.teamStatus.support_team_online\"><strong>We are open and can help with any questions</strong></div><div class=\"live-header\" ng-show=\"session.userStatus.user_sda && !session.teamStatus.support_team_online\">We are currently closed. We will respond during business hours</div><div id=\"contact-chat-panel\" class=\"contact-content contact-transcript\" ng-class=\"{\'menu-only-mode\': session.menuOnlyMode || showTyping}\" ng-hide=\"session.errorMessage\"><div ng-repeat=\"comment in session.transcript track by comment.id\" class=\"comment\" ng-class=\"\'comment-\' + comment.userType\" ng-hide=\"!comment.content\"><div class=\"username\" ng-bind=\"comment.displayName\"></div><p ng-bind-html=\"comment.content\"></p><youtube-thumbnail ng-if=\"comment.youtube_key\" key=\"{{comment.youtube_key}}\"></youtube-thumbnail></div><div class=\"bot-menu-container\" ng-class=\"{ disable: disableMenu }\"><div ng-show=\"session.menu\" class=\"bot-menu\"><bot-menu-button ng-repeat=\"menuItem in session.menu track by menuItem.key\" menu-item=\"menuItem\" handler=\"injectMenuQuestion\" disable=\"disableMenu\"></bot-menu-button></div></div><bot-typing show=\"showTyping\" ticket-mode=\"session.activeTicket\" with-menu=\"(!disableMenu && !!session.menu)\"></bot-typing></div><div class=\"contact-content contact-errors\" ng-show=\"session.errorMessage\"><p>{{ session.errorMessage }}</p><button type=\"button\" class=\"button hollow tiny\" ng-click=\"allReset()\">Reset chat session</button></div><div class=\"contact-panel-input\" ng-hide=\"session.errorMessage\" ng-class=\"{\'hide\': session.menuOnlyMode || showTyping }\"><textarea ng-user-input=\"getInput\" input-is-empty=\"inputIsEmpty\" busy=\"bot.busy\" ng-disabled=\"session.errorMessage || bot.busy || session.menuOnlyMode\"></textarea><div class=\"suggested-questions\" ng-show=\"inputIsEmpty\"><span class=\"question-tag\" ng-class=\"{\'start-again\': question.isStartAgain }\" ng-click=\"injectSuggestion(question.content, question.key)\" ng-repeat=\"question in suggestions track by $index\">{{ question.button }}</span></div></div></div></div>");
}]);
angular.bootstrap(document.getElementById('ng-bot'), ['bot']);